
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { UserBadge } from '@/types/badge';

interface BadgeDisplayProps {
  badge: UserBadge;
  earned?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const BadgeDisplay = ({ badge, earned = true, size = 'md' }: BadgeDisplayProps) => {
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-12 h-12 text-sm',
    lg: 'w-16 h-16 text-base'
  };

  return (
    <div className={`flex flex-col items-center space-y-1 ${earned ? '' : 'opacity-40'}`}>
      <div className={`
        ${sizeClasses[size]} 
        ${earned ? badge.color : 'bg-gray-300'} 
        rounded-full flex items-center justify-center text-white font-bold
        ${earned ? 'shadow-lg' : ''}
      `}>
        <span className="text-lg">{badge.icon}</span>
      </div>
      <div className="text-center">
        <div className={`font-medium ${size === 'sm' ? 'text-xs' : 'text-sm'}`}>
          {badge.name}
        </div>
        {size !== 'sm' && (
          <div className="text-xs text-gray-500 max-w-20 text-center">
            {badge.description}
          </div>
        )}
      </div>
    </div>
  );
};

export default BadgeDisplay;
